import { render, staticRenderFns } from "./OwnersWebsite.vue?vue&type=template&id=7196fe2e&scoped=true&"
import script from "./OwnersWebsite.vue?vue&type=script&lang=js&"
export * from "./OwnersWebsite.vue?vue&type=script&lang=js&"
import style0 from "./OwnersWebsite.vue?vue&type=style&index=0&id=7196fe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196fe2e",
  null
  
)

export default component.exports